import { assign } from 'xstate';
import {
  controllersComponentsMapper,
  controllersEnum,
  removeSpecificControllers,
} from '../../../../logic/controllers';
import { gameLaunchModel } from '../../../../model/game';
import { LogicContext } from '../../types';

export const createGameLaunchActions = () => {
  const actions = {
    openGameInCurrentTab: (context: LogicContext, event: any) => {
      gameLaunchModel.openGameInCurrentTab(
        event.data.gameToLaunch.launchUrl,
        context.deviceInfo.deviceType,
        context.deviceInfo.deviceOs
      );
    },

    removeGameLaunchController: assign((context: LogicContext) => {
      return {
        ...context,
        controllersData: removeSpecificControllers(
          context.controllersData,
          controllersComponentsMapper[controllersEnum.GAME_LAUNCHER]
        ),
      };
    }),
  };

  return actions;
};
